import i18next from 'i18next';

i18next.addResources('es_CL', 'ProductBanner', {
  productOutOfStock: 'Producto sin Stock',
  unavailableProductMessage: 'Lamentamos no tenerte este producto en este momento :('
});
